import DeleteIcon from 'assets/icons/delete';
import { IconButton } from '@mui/material';
import React from 'react';

const FileDeleteIconButton = React.forwardRef(({ onClick, disabled = false, ...rest }, ref) => {
	return (
		<IconButton
			ref={ref}
			sx={{ padding: 0, cursor: 'pointer', width: '34px', height: '34px' }}
			onClick={onClick}
			disabled={disabled}
			{...rest}
		>
			<DeleteIcon color="#ff4d4f" width="20px" height="20px" />
		</IconButton>
	);
});

FileDeleteIconButton.displayName = 'FileDeleteIconButton';

export default FileDeleteIconButton;
